import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../_redux/student-report/StudentReportAction";
import * as uiHelpers from "../StudentReportUIHelpers";
import {
  getHandlerTableChange,  
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useStudentReportUIContext } from "../StudentReportUIContext";
import { FilterButtonsTable } from "./FilterButtonsTable";

export function StudentReportTable() {
  // Student Report UI Context
  const studentReportUIContext = useStudentReportUIContext();
  const studentReportUIProps = useMemo(() => {
    return {
      columns: studentReportUIContext.columns,
      queryParams: studentReportUIContext.queryParams,
      setQueryParams: studentReportUIContext.setQueryParams
    };
  }, [studentReportUIContext]);

  // Getting curret state of Student Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentReport }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Student Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getStudentReport(studentReportUIProps.queryParams));
    return () => dispatch(actions.cleanStudentReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentReportUIProps.queryParams, dispatch]);

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: studentReportUIProps.queryParams.pageSize,
    page: studentReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <FilterButtonsTable />
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? [] }
              columns={studentReportUIProps.columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                studentReportUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>
  );
}